import React, { createContext, useReducer } from "react";
import ActionMenu from "./ActionMenu";
import Invoices from "./Invoices";
import PricingLink from "./PricingLink";
import Status from "./Status";
import subscriptionReducer, { buildInitialSubscriptionState } from "./reducer";

export const SubscriptionContext = createContext(null);
export const SubscriptionDispatchContext = createContext(null);

const Subscription = ({ data }) => {
  const [state, dispatch] = useReducer(
    subscriptionReducer,
    buildInitialSubscriptionState(data),
  );

  return (
    <SubscriptionContext.Provider value={state}>
      <SubscriptionDispatchContext.Provider value={dispatch}>
        <div className="my-5 flex min-w-[500px] flex-col gap-5">
          <PricingLink />
          <Status />
          <ActionMenu />
          <Invoices />
        </div>
      </SubscriptionDispatchContext.Provider>
    </SubscriptionContext.Provider>
  );
};

export default Subscription;
